import codeSnippet from '../plugins/codeSnippet'

export default function () {
    codeSnippet()
}
